/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(function() {
  $('.well').bind('closed', function() {
    return $.ajax({
      url: '/ajax/remove_info_text/' + $(this).data('id'),
      type: 'delete',
      dataType: 'script'
    });
  });

  $('.alert').bind('closed', function() {
    if ($(this).data('id')) {
      return $.ajax({
        url: '/ajax/remove_info_text/' + $(this).data('id'),
        type: 'delete',
        dataType: 'script'
      });
    }
  });

  return $( "input:submit, a.buttonStyleLink" ).button();
});

document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById('desc-container');
  const toggle = document.getElementById('desc-toggle');

  if (container && toggle) {
    const showMoreText = toggle.dataset.showMore || toggle.textContent;
    const showLessText = toggle.dataset.showLess || toggle.textContent;

    toggle.textContent = showMoreText;

    toggle.addEventListener('click', function () {
      const expanded = container.classList.toggle('expanded');
      toggle.textContent = expanded ? showLessText : showMoreText;
      toggle.setAttribute('aria-expanded', expanded);
    });
  }
});
